import useControlledState from '@library/common/hooks/use-controlled-state';
import { DetailedHTMLProps, Dispatch, FC, ForwardedRef, HTMLAttributes, SetStateAction, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { AccordianContext } from '../context/accordian-context';

interface AccordianProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    expanded?: boolean;
    setExpanded?: Dispatch<SetStateAction<boolean>>;
    defaultExpanded?: boolean;
    ref?: ForwardedRef<HTMLDivElement>;
}

const Accordian = forwardRef((props: AccordianProps, ref: ForwardedRef<HTMLDivElement>) => {
    const {
        expanded: controlledExpanded,
        setExpanded: controlledSetExpanded,
        defaultExpanded,
        children,
        className,
        ...rest
    } = props;

    const [isExpanded, setIsExpanded] = useControlledState({
        initialState: defaultExpanded,
        value: controlledExpanded,
        setValue: controlledSetExpanded,
    });

    return (
        <AccordianContext.Provider value={{ isExpanded, setIsExpanded }}>
            <div {...rest} ref={ref} className={twMerge(className)} aria-expanded={isExpanded}>
                {children}
            </div>
        </AccordianContext.Provider>
    );
});

Accordian.defaultProps = {
    defaultExpanded: false,
};

export default Accordian;
